import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import FuzzyText from '../components/FuzzyText';
import Silk from '../components/SilkBackground';

export default function NotFound() {
  useEffect(() => {
    document.title = 'Page Not Found - Lincoln AIM';
  }, []);
  const [enableHover] = useState(true);

  return (
    <>
    {/* Silk background */}
    <div className="fixed inset-0 -z-10 pointer-events-none">
        <Silk
          speed={10}
          scale={1}
          color="#e3c8b3"
          noiseIntensity={1.5}
          rotation={0}
        />
    </div>

    <div className="min-h-screen flex flex-col items-center justify-center bg-[#f2d6c0]/80 backdrop-blur-md px-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
        className="flex flex-col items-center"
      >
        
        <FuzzyText
          fontSize="clamp(4rem, 16vw, 10rem)"
          fontWeight={900}
          color="#111"
          baseIntensity={0.2}
          hoverIntensity={0.5}
          enableHover={enableHover}
        >
          404
        </FuzzyText>
        
        <h2 className="text-2xl font-semibold text-gray-900 mb-2 mt-2">Oops! Page not found.</h2>
        <p className="text-lg text-gray-800 font-bold mb-8 text-center max-w-md mt-4">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <a
          href="/"
          className="bg-black text-white px-6 py-3 rounded shadow hover:bg-gray-900 transition font-semibold text-lg"
        >
          Go Back Home
        </a>
      </motion.div>
    </div>
    </>
    
  );
} 